export const services = [
  {
    title: "AC Repair & Installation",
    description:
      "Quick diagnosis, gas refilling, installation, and annual maintenance for smooth cooling.",
    details:
      "Our AC technicians inspect cooling output, electrical load, and airflow before repair. We handle installation, pipe setup, drainage correction, and safe commissioning with final performance testing.",
    image: "servicesimg/install.PNG",
    alt: "AC repair and installation service",
  },
  {
    title: "Freezer & Fridge Repair",
    description:
      "Cooling issues, compressor replacement, and thermostat checks handled by experts.",
    details:
      "We diagnose cooling loss, unusual noise, and gas-line issues in both fridges and deep freezers. Service includes thermostat checks, condenser cleaning, compressor support, and reliable part replacement.",
    image: "servicesimg/fredge.PNG",
    alt: "Freezer and fridge repair service",
  },
  {
    title: "Washing Machine Repair",
    description:
      "Top-load and front-load repairs including motor, drum, and drainage fixes.",
    details:
      "Repairs cover inlet/outlet faults, drum imbalance, motor noise, and spin-cycle failure. We inspect control boards, belts, drainage lines, and run a full test cycle after service.",
    image: "servicesimg/washing.PNG",
    alt: "Washing machine repair service",
  },
  {
    title: "Geyser Service & Repair",
    description:
      "Heating element replacement, leakage fixes, and thermostat calibration.",
    details:
      "Geyser servicing includes element and thermostat checks, leakage repair, sediment cleaning, and electrical safety inspection. We ensure steady hot water output with secure operation.",
    image: "servicesimg/gyser.PNG",
    alt: "Geyser service and repair",
  },
  {
    title: "Electrical Wiring",
    description:
      "Safe wiring, switches, MCB upgrades, and complete home wiring solutions.",
    details:
      "We provide safe rewiring, switchboard correction, MCB upgrades, and fault detection for homes and shops. All work is done with load safety checks and neat finish standards.",
    image: "servicesimg/wire.PNG",
    alt: "Electrical wiring service",
  },
  {
    title: "Annual Maintenance",
    description:
      "Planned servicing to keep appliances efficient, safe, and long-lasting.",
    details:
      "Our annual plans include scheduled cleaning, preventive checkups, and early fault detection for key appliances. This reduces breakdowns, improves efficiency, and extends equipment life.",
    image: "servicesimg/annual.PNG",
    alt: "Annual maintenance service",
  },
];

export const featuredServices = [
  {
    id: "ac-service",
    title: "AC Service",
    description:
      "Complete checkup, indoor and outdoor cleaning, and performance tuning for better cooling.",
    image: "/1.png",
    alt: "Technician performing AC service",
  },
  {
    id: "ac-gas-fill",
    title: "AC Gas Fill",
    description:
      "Accurate gas pressure testing and refill for stable cooling with safe handling.",
    image: "/2.png",
    alt: "AC gas refill service",
  },
];

export const cleaningServices = [
  {
    title: "AC Deep Cleaning",
    description:
      "Coil, filter, and blower cleaning for fresh air and lower power bills.",
  },
  {
    title: "Washing Machine Cleaning",
    description:
      "Tub, filter, and drainage cleaning to remove odor and residue build-up.",
  },
  {
    title: "Geyser Cleaning",
    description: "Scale removal and tank sanitization for safe, efficient heating.",
  },
];

export const testimonials = [
  {
    name: "Pooja Sharma",
    quote:
      "Quick response and my AC was cooling perfectly the same day. Highly recommended!",
  },
  {
    name: "Rahul Verma",
    quote:
      "Professional team. They fixed my geyser leak and cleaned it too. Great service.",
  },
  {
    name: "Meera Singh",
    quote: "Washing machine repair was hassle-free and reasonably priced.",
  },
];

export const instagramReels = [
  {
    url: "https://www.instagram.com/p/DSXb1K7kddr/",
  },
];

export const acServiceProcessSteps = [
  {
    title: "1. Pre Service Checkup",
    description:
      "Our technician checks airflow, filter condition, cooling level, and overall AC health before starting work.",
    image: "/screenshots/work-1.png",
    alt: "Pre service AC checkup",
  },
  {
    title: "2. Indoor Unit Cleaning",
    description:
      "We clean filters, cooling coil, and blower area inside the indoor unit to improve air quality and cooling performance.",
    image: "/screenshots/work-2.png",
    alt: "Indoor AC unit cleaning",
  },
  {
    title: "3. Outdoor Unit Cleaning",
    description:
      "The outdoor condenser is cleaned carefully to remove dust buildup and maintain proper heat release and efficiency.",
    image: "/screenshots/work-3.png",
    alt: "Outdoor AC unit cleaning",
  },
];

export const acGasFillProcessSteps = [
  {
    title: "1. Cooling and Pressure Check",
    description:
      "We inspect cooling performance and check suction and discharge pressure to confirm if gas refill is required.",
    image: "/screenshots/work-1.png",
    alt: "AC pressure and cooling check",
  },
  {
    title: "2. Leak Test and Vacuum Process",
    description:
      "Before gas charging, we check for leakage and perform vacuuming so moisture and air do not reduce AC efficiency.",
    image: "/2.png",
    alt: "AC leak testing and vacuum process",
  },
  {
    title: "3. Gas Charging and Final Testing",
    description:
      "We fill gas to the recommended level and run complete cooling tests for stable and efficient performance.",
    image: "/screenshots/work-3.png",
    alt: "AC gas charging and final cooling test",
  },
];
